import {createSelector} from 'reselect';

export const isInternalUser = state => state.account.internal;
export const getCountry = state => state.account.country;
export const getSavedDesigns = state => state.account.savedDesigns;
export const getSavedDesignsLength = state => state.account.savedDesigns.length;
export const hasMoreSavedDesigns = state => state.account.hasMoreSavedDesigns;
export const getSavedDesignsStatus = state => state.account.savedDesignsStatus;
export const orderedBefore = state => state.account.orderedBefore;

export const selectedSavedDesign = state => {
  const savedDesignIndex = state.account.selectedSavedDesignIndex;
  if (savedDesignIndex) {
    const savedDesigns = state.account.savedDesigns;
    const {compositeId, designName} = savedDesigns[savedDesignIndex];
    return {compositeId, designName};
  }
};

export const isPreferSingles = state => state.account.preferSingles;

export const selectedSuggestionsFromSavedDesigns = createSelector(
  [getSavedDesigns],
  savedDesigns => {
    if (!savedDesigns?.length) {
      return [];
    }

    return savedDesigns.map(design => {
      return {
        id: design.productId,
        cid: design.compositeId,
        designDigest: design.designDigest,
        name: design.designName,
        imageSrc: design.imageSrc,
        products: design.products
      };
    });
  }
);
